import styled from "styled-components";

const LeftBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default LeftBox;
